import React, { useEffect, useRef, useState } from 'react';
import Minus from '/public/svgs/minus-icon-cl2.svg';
import Plus from '/public/svgs/plus-icon-cl2.svg';
import styles from './Collapse.module.scss';

interface CollapseProps {
  title?: string;
  text?: string;
}

const Collapse: React.FC<CollapseProps> = ({ title, text }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [height, setHeight] = useState<number | undefined>(undefined);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isCollapsed) setHeight(ref.current?.getBoundingClientRect().height);
    else setHeight(0);
  }, [isCollapsed]);

  return (
    <div className={styles.collapse}>
      <div className='container'>
        {title && (
          <div className={styles.title} onClick={toggleCollapse}>
            <div dangerouslySetInnerHTML={{ __html: title }} />
            {!isCollapsed ? <Plus /> : <Minus />}
          </div>
        )}

        <div className={isCollapsed ? styles.show : styles.hide} style={{ height }}>
          {text && <div ref={ref} dangerouslySetInnerHTML={{ __html: text }} />}
        </div>

      </div>
    </div>
  );
};

export default Collapse;


